// const { TMap } = window;

export const mapAttrsHandlers = {
  latitude(val: number, mapInstance: LooseObject): void {
    const lng = mapInstance.getCenter().getLng();
    mapInstance.setCenter(new TMap.LatLng(val, lng));
  },
  longitude(val: number, mapInstance: LooseObject): void {
    const lat = mapInstance.getCenter().getLat();
    mapInstance.setCenter(new TMap.LatLng(lat, val));
  },
  zoom(val: number, mapInstance: LooseObject): void {
    mapInstance.setZoom(val);
  },
  rotation(val: number, mapInstance: LooseObject): void {
    mapInstance.setRotation(val);
  },
  pitch(val: number, mapInstance: LooseObject): void {
    mapInstance.setPitch(val);
  },
  scale(val: number, mapInstance: LooseObject): void {
    mapInstance.setScale(val);
  },
  draggable(val: boolean, mapInstance: LooseObject): void {
    mapInstance.setDraggable(val);
  },
  viewMode(val: string, mapInstance: LooseObject): void {
    mapInstance.setViewMode(val);
  },
  zoomRange(val: number[], mapInstance: LooseObject): void {
    mapInstance.setMinZoom(val[0]).setMaxZoom(val[1]);
  },
  offset(val: OffsetOption, mapInstance: LooseObject): void {
    mapInstance.setOffset(val);
  },
  vectorBaseMap(val: VectorBaseMapOption, mapInstance: LooseObject): void {
    mapInstance.setBaseMap({
      type: 'vector',
      features: Object.entries(val).filter(([, value]) => value)
        .map(([feature]) => feature),
    });
  },
  showSatellite(val: boolean, mapInstance: LooseObject, mapProps: LooseObject) {
    const features = Object.entries(mapProps.showSatellite ? mapProps.satelliteBaseMap : mapProps.vectorBaseMap)
      .filter(([, value]) => value)
      .map(([feature]) => feature);
    if (!val) {
      mapInstance.setBaseMap({
        type: 'vector',
        features,
      });
      return;
    }
    mapInstance.setBaseMap({
      type: 'satellite',
      features,
    });
  },
  mapStyleId(val: string, mapInstance: LooseObject): void {
    mapInstance.setMapStyleId(val);
  },
  zoomControlPostion(val: number, mapInstance: LooseObject): void {
    mapInstance.getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM).setPosition(val);
  },
  rotationControlPostion(val: number, mapInstance: LooseObject): void {
    mapInstance.getControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION).setPosition(val);
  },
};

